import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const StyledInputContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const ContainerSenha = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InputSenha = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  input {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border: 1.6px solid #cfd8dc;
    border-radius: 10px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  input:focus {
    border-color: #b79931; /* cor da marca */
    box-shadow: 0 0 0 4px rgba(183, 153, 49, 0.16);
  }
`;

export const IconVisible = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  color: #6b7280;
`;

export const ContainerRequisitos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    display: flex;
    align-items: center;
    padding-inline: 0;
    margin: 0 0 8px 0;
    font-size: 16px;
    color: grey;
  }

  ul {
    padding-left: 18px;
    margin: 0;
  }
`;
